import { Controller } from "@hotwired/stimulus"
import docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from 'file-saver';
import ky from 'ky';
import dayjs from 'dayjs'


// Connects to data-controller="docxtemplater"
export default class extends Controller {
  static targets = ["button"]
  connect() {
  }
  downloadDocx(event) {
    event.preventDefault();
    // получаем ссылку на файл и информацию
    let booking_id = this.buttonTarget.dataset.bookingId
    let car_id = this.buttonTarget.dataset.carId
    if (booking_id == undefined || car_id == undefined) {
      alert("Не удалось получить данные для формирования документа");
      return;
    }
    let url = `https://rentprog.net/api/v1/vseprokaty_company_documents`
    if (document.querySelector('meta[name="environment"]').content == "development") {
      url = `http://localhost:3000/api/v1/vseprokaty_company_documents`
    }
    let doc_url, client, booking, car, day_cost;
    try {
      this.buttonTarget.innerHTML = ` <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-hourglass-high" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <path d="M6.5 7h11"></path>
        <path d="M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z"></path>
        <path d="M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z"></path>
      </svg> Загрузка...`;
      const response = ky.post(url, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': document.querySelector('meta[name="crfs-token"]').content
        },
        json: {
          car_id: car_id,
          booking_id: booking_id
        },
        hooks: {
          beforeError: [
            error => {
              const { response } = error;
              if (response && response.body) {
                error.name = 'Loading Error';
                error.message = `${response.body.message} (${response.status})`;
              }
              this.buttonTarget.innerHTML = `Скачать договор`;
              console.log(error);
              alert(error);
            }
          ]
        },
        retry: 0
      });
      response.then((data) => {
        this.buttonTarget.innerHTML = `Скачать договор`;
        if (data.status == 200) {
          data.json().then((data) => {
            doc_url = data.template_url
            client = data.client
            booking = data.booking
            car = data.car
            day_cost = data.day_cost
            generate(doc_url);
          })
        }
      });
    } catch (error) {
      console.log(error);
      alert(error);
    }

    function loadFile(url, callback) {
      PizZipUtils.getBinaryContent(url, callback);
    }
    function generate(doc_url) {
      loadFile(
        doc_url,
        function (error, content) {
          if (error) {
            throw error;
          }
          const zip = new PizZip(content);
          const doc = new docxtemplater(zip, {
            paragraphLoop: true,
            linebreaks: true,
          });

          // Считаю комиссию в сутки
          let commission = booking.aggr_commission;
          let commission_day = commission / (booking.days > 0 ? booking.days : 1);

          // Считаю доп сервисы
          let additional_services =
            (booking.hours_cost > 0
              ? booking.additional_hours * booking.price_hour
              : 0) +
            booking.hours_cost_end +
            booking.delivery +
            booking.delivery_end +
            booking.equipment +
            booking.clean_payment +
            booking.damage +
            booking.gas +
            booking.add_drivers_cost +
            booking.insurance +
            booking.fine +
            booking.other +
            booking.other_end;

          // Render the document (Replace {first_name} by John, {last_name} by Doe, ...)
          doc.render({
            date: dayjs().format("DD/MM/YY"),
            date_short: dayjs().format("DD/MM"),
            serial_number: booking.serial_number ? booking.serial_number : "      ",
            employee_full_name: "      ",
            employee_short_name: "      ",
            first_name: client.name ? client.name : "      ",
            middle_name: client.middlename ? client.middlename : "      ",
            last_name: client.lastname ? client.lastname : "      ",
            short_name: client.fio ? client.fio : "      ",
            client_id: client.id ? client.id : "      ",
            booking_id: booking.id ? booking.id : "      ",
            car_id: car.id ? car.id : "      ",
            date_birth: client.birthday
              ? dayjs(client.birthday, "YYYY-MM-DD").format("DD-MM-YYYY")
              : "      ",
            passport_series: client.passport_series
              ? client.passport_series
              : "      ",
            passport_number: client.passport_number
              ? client.passport_number
              : "      ",
            passport_issued: client.passport_issued
              ? client.passport_issued
              : "      ",
            driver_series: client.driver_series
              ? client.driver_series
              : "      ",
            driver_number: client.driver_number
              ? client.driver_number
              : "      ",
            driver_issued: client.driver_issued
              ? client.driver_issued
              : "      ",
            inn: client.inn ? client.inn : "      ",
            country: client.country ? client.country : "      ",
            city: client.city ? client.city : "      ",
            address: client.address ? client.address : "      ",
            phone: client.phone ? client.phone : "      ",
            email: client.email ? client.email : "      ",
            start_date: booking.start_date
              ? booking.start_date
              : "      ",
            end_date: booking.end_date ? booking.end_date : "      ",
            start_date_short: booking.start_date
              ? dayjs(booking.start_date, "DD-MM-YYYY H:mm").format(
                "DD.MM.YYYY"
              )
              : "     ",
            end_date_short: booking.end_date
              ? dayjs(booking.end_date, "DD-MM-YYYY H:mm").format(
                "DD.MM.YYYY"
              )
              : "     ",
            day_cost: day_cost,
            price: booking.price ? booking.price : "      ",
            day_cost_without_commission: (day_cost - commission_day).toFixed(2),
            price_without_commission: booking.price
              ? (booking.price - commission_day).toFixed(2)
              : "      ",
            cost_without_commission: booking.rental_cost
              ? (booking.rental_cost - commission).toFixed(2)
              : "      ",
            selected_price: booking.selected_price
              ? booking.selected_price
              : "      ",
            cost: booking.rental_cost ? booking.rental_cost : "      ",
            days: booking.days ? booking.days : "      ",
            location_start: booking.location_start
              ? booking.location_start
              : "      ",
            location_end: booking.location_end
              ? booking.location_end
              : "      ",
            delivery_start: booking.delivery
              ? booking.delivery
              : "      ",
            delivery_end: booking.delivery_end
              ? booking.delivery_end
              : "      ",
            equipment: booking.equipment ? booking.equipment : "      ",
            hours_cost: booking.hours_cost
              ? booking.hours_cost
              : "      ",
            additional_hours: booking.additional_hours
              ? booking.additional_hours
              : "      ",
            add_drivers_cost: booking.add_drivers_cost
              ? booking.add_drivers_cost
              : "      ",
            insurance: booking.insurance ? booking.insurance : "      ",
            clean: booking.clean_payment
              ? booking.clean_payment
              : "      ",
            other: booking.other ? booking.other : "      ",
            has_delivery_start: booking.delivery ? true : false,
            has_delivery_end: booking.delivery_end ? true : false,
            has_equipment: booking.equipment ? true : false,
            has_additional_hours: booking.additional_hours ? true : false,
            has_hours_cost: booking.hours_cost ? true : false,
            has_add_drivers_cost: booking.add_drivers_cost ? true : false,
            has_insurance: booking.insurance ? true : false,
            has_clean: booking.clean_payment ? true : false,
            has_other: booking.other ? true : false,
            has_sale: booking.sale ? true : false,
            has_sale_cash: booking.sale_cash ? true : false,
            sale: booking.sale ? booking.sale : "",
            sale_cash: booking.sale_cash ? booking.sale_cash : "",
            start_mileage: "      ",
            end_mileage: "      ",
            car_name: booking.car_name ? booking.car_name : "      ",
            car_code: booking.car_code ? booking.car_code : "      ",
            car_number: "      ",
            car_vin: "      ",
            car_body: "      ",
            car_pts: "      ",
            car_reg: "      ",
            car_color: "      ",
            car_year: car.year ? car.year : "      ",
            car_fuel: car.fuel ? car.fuel : "      ",
            price_hour: car.price_hour ? car.price_hour : "      ",
            additional_services:
              additional_services > 0 ? additional_services : "      ",
            has_additional_services: additional_services > 0 ? true : false,
            deposit: booking.deposit ? booking.deposit : "      ",
            total: booking.total ? booking.total : "      ",
            total_without_commission:
              booking.total
                ? booking.total - commission
                : "      ",
            total_with_deposit:
              booking.total && booking.deposit
                ? booking.total + booking.deposit
                : "      ",
            total_with_deposit_without_commission:
              booking.total && booking.deposit
                ? booking.total + booking.deposit - commission
                : "      ",
            prepaid: 0,
            add_drivers_info: "      ",
            add_drivers_info_full: "      ",
            has_add_drivers: false,
            add_drivers_array: [],
            repair_cost: car.repair_cost ? car.repair_cost : "      ",
            franchise: car.franchise ? car.franchise : "      ",
            max_fine: car.max_fine ? car.max_fine : "      ",
            custom_field_1: booking.custom_field_1
              ? booking.custom_field_1
              : "      ",
            custom_field_2: booking.custom_field_2
              ? booking.custom_field_2
              : "      ",
            custom_field_3: booking.custom_field_3
              ? booking.custom_field_3
              : "      ",
            cars_custom_field_1: car.custom_field_1
              ? car.custom_field_1
              : "      ",
            cars_custom_field_2: car.custom_field_2
              ? car.custom_field_2
              : "      ",
            cars_custom_field_3: car.custom_field_3
              ? car.custom_field_3
              : "      ",
          });

          const blob = doc.getZip().generate({
            type: "blob",
            mimeType:
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            // compression: DEFLATE adds a compression step.
            // For a 50MB output document, expect 500ms additional CPU time
            compression: "DEFLATE",
          });
          // Output the document using Data-URI
          saveAs(blob, "output.docx");
        }
      );
    };
  }
}
